import { render, staticRenderFns } from "./IdoneitaEdit.vue?vue&type=template&id=28609b32"
import script from "./IdoneitaEdit.vue?vue&type=script&lang=js"
export * from "./IdoneitaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports